import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store/index";
import App from "./App";
import "./i18n/config"; // Import i18n configuration
import ErrorFallback from "./components/ErrorBoundry/index";
import reportWebVitals from "./reportWebVitals";

import { ErrorBoundary } from "react-error-boundary";
import "./instrument";
import * as Sentry from "@sentry/react";
import { REACT_APP_SENTRY_ENV } from "./config";

const isLocal = REACT_APP_SENTRY_ENV === "local";
ReactDOM.render(
  <Provider store={store}>
    {isLocal ? (
      <ErrorBoundary
        onReset={() => {
          window.location.href = "/";
        }}
        FallbackComponent={ErrorFallback}
      >
        <App />
      </ErrorBoundary>
    ) : (
      <Sentry.ErrorBoundary fallback={ErrorFallback}>
        <App />
      </Sentry.ErrorBoundary>
    )}
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
